import React from "react";
import ServiceCrudTableRow from "./ServiceCrudTableRow";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const ServiceCrudTable = ({services, editData, deleteData}) => {
    let myAbilities = HelpAbility();

    const styles = {
        cell2: {
            padding: "15px"
        }, 
    }

    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th style={styles.cell2} scope="col">#</th>
                    <th style={styles.cell2} scope="col">Código</th>
                    <th style={styles.cell2} scope="col">Nombre</th>
                    <th style={styles.cell2} scope="col">Endpoint</th>
                    <th style={styles.cell2} scope="col">Visible</th>
                    {myAbilities.hasAny([C.A.SERVICE.UPDATE, C.A.SERVICE.DELETE]) && <th style={styles.cell2} scope="col">Acción</th>}
                </tr>
                </thead>
                <tbody>
                {
                    services.length > 0 ? services.map((el, i) => <ServiceCrudTableRow key={el._id} el={el} i={i}
                        editData={editData} deleteData={deleteData}/>) :
                        <tr>
                            <td colSpan="5">Sin datos</td>
                        </tr>
                }
                </tbody>
            </table>
        </div>
    );
}
export default ServiceCrudTable;
